<template>
  <el-dialog
    :title="!dataForm.isE ? '供应商进入优先库申请' : '供应商退出优先库申请'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="55%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" class="user-info-dialog-form">
      <el-tabs style="min-height: 50vh;">
        <el-tab-pane class="tab_style" :key="1" label="基础信息" >
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="供应商代码" prop="venderCode">
                <el-input v-model="dataForm.venderCode"  placeholder="供应商代码" :disabled= true></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="供应商名称" prop="venderName">
                <el-input v-model="dataForm.venderName" placeholder="供应商名称" :disabled=true></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="40">
              <el-form-item label="备注" prop="remarks">
              <el-col :span="12">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="dataForm.remarks">
                </el-input>
             </el-col>
             </el-form-item>
          </el-row>
        </el-tab-pane>
        <el-tab-pane class="tab_style" :key="2" label="附件文件">
          <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.venderInviteFid" :bizType="FILE_BIZ_TYPE"></FileUpDown>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button :loading="dataFormSubmitLoading" type="primary" size="mini" @click="dataFormSubmit()">提交申请</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,frozenThaw} from '@/controller/supplier'
  import FileUpDown from "@/views/common/file-up-down"
  import {firstApply} from "../../../../controller/supplier";
  
  export default {
    name: 'InExitIndex',
    data () {
      
      return {
        fileDialogVisible:false,
        dataFormSubmitLoading:false,
        visible: false,
        FILE_BIZ_TYPE:5,
        FILE_SUB_TYPE:0,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          isE:'',
          venderCode: '',
          venderName : '',
          remarks:'',
          workflowId:'',
          subcompanyId:'',
        },
        dataRule: {},
        files:[]
      }
    },

    components: {
        FileUpDown //上传附件
    },

    methods: {

            

      init (row) {
        this.visible = true
        this.dataForm.id = row.id || 0
        this.dataForm.isE = row.isE
        this.dataForm.workflowId = row.workflowId
        this.dataForm.subcompanyId = row.subcompanyId
        if(row.isE === 0){
            this.FILE_SUB_TYPE = 5
        }
        if(row.isE === 1){
            this.FILE_SUB_TYPE = 6
        }

        this.$nextTick(() => {
             this.$refs.FileUpDown.init("edit");
            this.$refs['dataForm'].resetFields()
          
        selectSupplierById(
                  {id : this.dataForm.id}
           ).then(data => {
             if (data && data.code === '00') {
               this.dataForm = {...this.dataForm, ...data.body}
             }
           })
        
        })
      },
      


      // 表单提交
      dataFormSubmit () {

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
              var flag;
              if(this.dataForm.isE === 0){
                flag = true;
              }
              if(this.dataForm.isE === 1){
                flag = false;
              }
           
            let params = {
              'supplierId': this.dataForm.venderInviteFid || undefined,
              'remark': this.dataForm.remarks,
              'flag': flag,
              'workflowId': this.dataForm.workflowId,
              'subcompanyId':this.dataForm.subcompanyId
            }
            this.dataFormSubmitLoading = true
            firstApply(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                      this.dataFormSubmitLoading = false
                    }
                  })
                } else {
                  this.dataFormSubmitLoading = false
                  this.$message.error(data.msg)
                }
              }).catch((e)=>{
                  this.dataFormSubmitLoading = false
              })
            
          }
        })
      },

    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>